import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import {
  updateCurrencyRateDetails,
  updateFormData,
} from "../../../../../store/slices/currency/currencyRateFormSlice";
import * as Yup from "yup";
import { useGetBasicDataQuery } from "../../../../../store/queries/global";

const useBuy = ({ refetch, closeModal }) => {
  const dispatch = useDispatch();

  const { selectedItemsDetails, selectedId } = useSelector(
    (state) => state.currencyRateForm
  );
  const { data: formData = {} } = useGetBasicDataQuery();

  const validation = Yup.object({
    cash_markup_value: Yup.number().when("cash_markup_type", {
      is: 2,
      then: (schema) =>
        schema
          .min(0, "Value must be at least 0")
          .max(100, "Value must be at most 100"),
    }),
    travel_markup_value: Yup.number().when("travel_markup_type", {
      is: 2,
      then: (schema) =>
        schema
          .min(0, "Value must be at least 0")
          .max(100, "Value must be at most 100"),
    }),
  });

  const formik = useFormik({
    initialValues: {
      cash_rate:
        selectedItemsDetails !== ""
          ? selectedItemsDetails?.buy_details?.[0]?.Cash
            ? selectedItemsDetails?.buy_details?.[0]?.Cash?.rate
            : selectedItemsDetails?.buy_details?.[1]?.Cash?.rate
          : "",
      cash_markup_type:
        selectedItemsDetails !== ""
          ? selectedItemsDetails?.buy_details?.[0]?.Cash
            ? selectedItemsDetails?.buy_details?.[0]?.Cash?.markup_type
            : selectedItemsDetails?.buy_details?.[1]?.Cash?.markup_type
          : "",
      cash_markup_value:
        selectedItemsDetails !== ""
          ? selectedItemsDetails?.buy_details?.[0]?.Cash
            ? selectedItemsDetails?.buy_details?.[0]?.Cash?.markup_value
            : selectedItemsDetails?.buy_details?.[1]?.Cash?.markup_value
          : "",
      cash_forex_rate:
        selectedItemsDetails !== ""
          ? selectedItemsDetails?.buy_details?.[0]?.Cash
            ? selectedItemsDetails?.buy_details?.[0]?.Cash?.total_amount
            : selectedItemsDetails?.buy_details?.[1]?.Cash?.total_amount
          : "",

      cash_status:
        selectedItemsDetails !== ""
          ? selectedItemsDetails?.buy_details?.[0]?.Cash?.status !== null
            ? selectedItemsDetails?.buy_details?.[0]?.Cash
              ? selectedItemsDetails?.buy_details?.[0]?.Cash?.status
              : selectedItemsDetails?.buy_details?.[1]?.Cash?.status
            : 0
          : 0,
      travel_card:
        selectedItemsDetails !== ""
          ? selectedItemsDetails?.buy_details?.[1]?.["Travel Card"]
            ? selectedItemsDetails?.buy_details?.[1]?.["Travel Card"]?.rate
            : selectedItemsDetails?.buy_details?.[0]?.["Travel Card"]?.rate
          : "",
      travel_markup_type:
        selectedItemsDetails !== ""
          ? selectedItemsDetails?.buy_details?.[1]?.["Travel Card"]
            ? selectedItemsDetails?.buy_details?.[1]?.["Travel Card"]?.markup_type
            : selectedItemsDetails?.buy_details?.[0]?.["Travel Card"]?.markup_type
          : "",
      travel_markup_value:
        selectedItemsDetails !== ""
          ? selectedItemsDetails?.buy_details?.[1]?.["Travel Card"]
            ? selectedItemsDetails?.buy_details?.[1]?.["Travel Card"]?.markup_value
            : selectedItemsDetails?.buy_details?.[0]?.["Travel Card"]?.markup_value
          : "",
      travel_forex_rate:
        selectedItemsDetails !== ""
          ? selectedItemsDetails?.buy_details?.[1]?.["Travel Card"]
            ? selectedItemsDetails?.buy_details?.[1]?.["Travel Card"]?.total_amount
            : selectedItemsDetails?.buy_details?.[0]?.["Travel Card"]?.total_amount
          : "",
      travel_status:
        selectedItemsDetails !== ""
          ? selectedItemsDetails?.buy_details?.[1]?.["Travel Card"]?.status !== null
            ? selectedItemsDetails?.buy_details?.[1]?.["Travel Card"]
              ? selectedItemsDetails?.buy_details?.[1]?.["Travel Card"]?.status
              : selectedItemsDetails?.buy_details?.[0]?.["Travel Card"]?.status
            : 0
          : 0,
      cash_lock:
        selectedItemsDetails !== ""
          ? (selectedItemsDetails?.buy_details?.[0]?.Cash
              ? selectedItemsDetails?.buy_details?.[0]?.Cash?.locked ??
                selectedItemsDetails?.buy_details?.[0]?.Cash?.lock
              : selectedItemsDetails?.buy_details?.[1]?.Cash?.locked ??
                selectedItemsDetails?.buy_details?.[1]?.Cash?.lock)
            ? 1
            : 0
          : 0,
      cash_is_all_branches:
        selectedItemsDetails !== ""
          ? (selectedItemsDetails?.buy_details?.[0]?.Cash
              ? selectedItemsDetails?.buy_details?.[0]?.Cash?.is_all_branches
              : selectedItemsDetails?.buy_details?.[1]?.Cash?.is_all_branches) ??
            1
          : 1,
      cash_branch_ids:
        selectedItemsDetails !== ""
          ? (selectedItemsDetails?.buy_details?.[0]?.Cash
              ? selectedItemsDetails?.buy_details?.[0]?.Cash?.branch_ids
              : selectedItemsDetails?.buy_details?.[1]?.Cash?.branch_ids) ?? []
          : [],
      travel_lock:
        selectedItemsDetails !== ""
          ? (selectedItemsDetails?.buy_details?.[1]?.["Travel Card"]
              ? selectedItemsDetails?.buy_details?.[1]?.["Travel Card"]?.locked ??
                selectedItemsDetails?.buy_details?.[1]?.["Travel Card"]?.lock
              : selectedItemsDetails?.buy_details?.[0]?.["Travel Card"]?.locked ??
                selectedItemsDetails?.buy_details?.[0]?.["Travel Card"]?.lock)
            ? 1
            : 0
          : 0,
      travel_is_all_branches:
        selectedItemsDetails !== ""
          ? (selectedItemsDetails?.buy_details?.[1]?.["Travel Card"]
              ? selectedItemsDetails?.buy_details?.[1]?.["Travel Card"]
                  ?.is_all_branches
              : selectedItemsDetails?.buy_details?.[0]?.["Travel Card"]
                  ?.is_all_branches) ?? 1
          : 1,
      travel_branch_ids:
        selectedItemsDetails !== ""
          ? (selectedItemsDetails?.buy_details?.[1]?.["Travel Card"]
              ? selectedItemsDetails?.buy_details?.[1]?.["Travel Card"]
                  ?.branch_ids
              : selectedItemsDetails?.buy_details?.[0]?.["Travel Card"]
                  ?.branch_ids) ?? []
          : [],
    },

    validationSchema: validation,
    enableReinitialize: true,
    validateOnChange: true,
    validateOnMount: true,
    onSubmit: (values, { resetForm }) => {
      let obj = {
        // NOTE: identifier key for the currency rate update payload.
        currency_id: selectedId,
        type: 1,
        product: [
          {
            id: selectedItemsDetails?.buy_details?.[0]?.["Cash"]
              ? selectedItemsDetails?.buy_details?.[0]?.["Cash"]?.id
              : selectedItemsDetails?.buy_details?.[1]?.["Cash"]?.id,
            markup_type: values?.cash_markup_type,
            markup_value: +values?.cash_markup_value ?? 0,
            rate: values?.cash_rate,
            total_amount: values.cash_forex_rate,
            status: +values?.cash_status ?? 0,
            lock: +values?.cash_lock ?? 0,
            is_all_branches: +values?.cash_is_all_branches ?? 0,
            ...(+values?.cash_is_all_branches
              ? {}
              : {
                  branch_ids: (values?.cash_branch_ids || []).map(
                    (v) => v?._id ?? v
                  ),
                }),
          },
          {
            id: selectedItemsDetails?.buy_details?.[1]?.["Travel Card"]
              ? selectedItemsDetails?.buy_details?.[1]?.["Travel Card"]?.id
              : selectedItemsDetails?.buy_details?.[0]?.["Travel Card"]?.id,
            markup_type: values?.travel_markup_type,
            markup_value: +values?.travel_markup_value ?? 0,
            rate: values?.travel_card,
            total_amount: values.travel_forex_rate,
            status: +values?.travel_status ?? 0,
            lock: +values?.travel_lock ?? 0,
            is_all_branches: +values?.travel_is_all_branches ?? 0,
            ...(+values?.travel_is_all_branches
              ? {}
              : {
                  branch_ids: (values?.travel_branch_ids || []).map(
                    (v) => v?._id ?? v
                  ),
                }),
          },
        ],
      };

      dispatch(updateCurrencyRateDetails(obj)).then((response) => {
        if (response?.payload?.data?.success) {
          resetForm();
          closeModal?.();
          refetch();
          dispatch(
            updateFormData((state) => {
              state.showRateEditModal = false;
            })
          );

          toast.success(response?.payload?.data?.message);
        } else {
          // Rejected: payload is the error body { success, message, data }
          // where data holds field errors keyed as `product.<index>.<field>`.
          const handled = applyServerErrors(response?.payload?.data, {
            0: "cash",
            1: "travel",
          });
          if (!handled && response?.payload?.message) {
            toast.error(response?.payload?.message);
          }
        }
      });
    },
  });

  // Maps backend validation errors keyed as `product.<index>.<field>`
  // (e.g. "product.0.is_all_branches") onto the matching formik field so the
  // message renders inline. Returns true if any error was applied.
  const applyServerErrors = (errors, prefixByIndex) => {
    if (!errors || typeof errors !== "object") return false;
    const suffixMap = {
      total_amount: "markup_value",
      markup_value: "markup_value",
      markup_type: "markup_type",
      rate: "rate",
      is_all_branches: "branch_ids",
      branch_ids: "branch_ids",
      lock: "lock",
      status: "status",
    };
    let handled = false;
    Object.entries(errors).forEach(([key, messages]) => {
      const match = /^product\.(\d+)\.(.+)$/.exec(key);
      if (!match) return;
      const prefix = prefixByIndex[Number(match[1])];
      if (!prefix) return;
      const suffix = suffixMap[match[2]] ?? match[2];
      // Buy's travel rate field is named `travel_card`, not `travel_rate`.
      const fieldName =
        prefix === "travel" && suffix === "rate"
          ? "travel_card"
          : `${prefix}_${suffix}`;
      const message = Array.isArray(messages) ? messages[0] : messages;
      formik.setFieldError(fieldName, message);
      handled = true;
    });
    return handled;
  };

  // updating the completed percentage of butfields
  const buyFields = ["cash_markup_value", "travel_markup_value"];

  var completedFields = buyFields?.filter((field) => {
    return !!!formik?.errors[field];
  });

  const completedPercentageBuy =
    (completedFields.length / buyFields.length) * 100;

  useEffect(() => {
    // Dispatch the action to update the Redux state
    dispatch(
      updateFormData((state) => {
        state.CompletedPercentage = {
          ...state.CompletedPercentage,
          Buy: completedPercentageBuy,
        };
      })
    );
    //eslint-disable-next-line
  }, [completedPercentageBuy]);

  const handleCloseModal = () => {
    dispatch(
      updateFormData((state) => {
        state.showRateEditModal = false;
      })
    );
  };

  const setTypeFieldValue = (id) => {
    if (formik.values?.cash_markup_value) {
      handleChangeCashForex(formik.values?.cash_markup_value, id);
    }
  };

  const setTravelTypeFieldValue = (id) => {
    if (formik.values?.travel_markup_value) {
      handleChangeTravelForex(formik.values?.travel_markup_value, id);
    }
  };

  const handleChangeCashForex = (e, id) => {
    if (e.target) {
      formik.setFieldValue("cash_markup_value", e.target.value);
    } else {
      formik.setFieldValue("cash_markup_value", e);
    }

    const percentage = Number(
      e?.target?.value ?? formik.values?.cash_markup_value
    );
    const cashRate = Number(formik.values?.cash_rate) || 0;
    const cashMarkup = Math.abs(percentage) || 0;
    let rate = 0;

    if (id === 1) {
      const formattedRate = percentage.toFixed(4);
      formik.setFieldValue("cash_forex_rate", formattedRate);
    } else if (id === 2) {
      if (percentage > 0) {
        rate = cashRate + cashRate * (cashMarkup / 100);
      } else if (percentage < 0) {
        rate = cashRate - cashRate * (cashMarkup / 100);
      } else {
        rate = cashRate;
      }
      const formattedRate = rate.toFixed(4);
      formik.setFieldValue("cash_forex_rate", formattedRate);
    } else {
      rate = cashRate + percentage;
      const formattedRate = rate.toFixed(4);
      formik.setFieldValue("cash_forex_rate", formattedRate);
    }
  };

  const handleChangeTravelForex = (e, id) => {
    if (e.target) {
      formik.setFieldValue("travel_markup_value", e.target.value);
    } else {
      formik.setFieldValue("travel_markup_value", e);
    }

    const percentage = Number(
      e?.target?.value ?? formik.values?.travel_markup_value
    );
    const TravelRate = Number(formik.values?.travel_card) || 0;
    const TravelMarkup = Math.abs(percentage) || 0;
    let rate = 0;
    if (id === 1) {
      const formattedRate = percentage.toFixed(4);
      formik.setFieldValue("travel_forex_rate", formattedRate);
    } else if (id === 2) {
      if (percentage > 0) {
        rate = TravelRate + TravelRate * (TravelMarkup / 100);
      } else if (percentage < 0) {
        rate = TravelRate - TravelRate * (TravelMarkup / 100);
      } else {
        rate = TravelRate;
      }
      const formattedRate = rate.toFixed(4);
      formik.setFieldValue("travel_forex_rate", formattedRate);
    } else {
      rate = TravelRate + percentage;
      const formattedRate = rate.toFixed(4);
      formik.setFieldValue("travel_forex_rate", formattedRate);
    }
  };

  // Pre-calculate the (disabled) forex-rate fields on initial load so they are
  // populated from rate + markup before the user touches the markup input.
  // Only runs when the forex rate is empty (e.g. the no-saved-data fallback),
  // so an existing total_amount from the edit API is left untouched.
  useEffect(() => {
    if (!formik.values?.cash_forex_rate && formik.values?.cash_markup_type) {
      handleChangeCashForex(
        formik.values?.cash_markup_value ?? "",
        formik.values?.cash_markup_type
      );
    }
    if (!formik.values?.travel_forex_rate && formik.values?.travel_markup_type) {
      handleChangeTravelForex(
        formik.values?.travel_markup_value ?? "",
        formik.values?.travel_markup_type
      );
    }
    // eslint-disable-next-line
  }, [selectedItemsDetails]);

  return {
    formik,
    formData,
    handleCloseModal,
    handleChangeCashForex,
    handleChangeTravelForex,
    setTypeFieldValue,
    setTravelTypeFieldValue,
  };
};

export default useBuy;
